var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormWrapper',{attrs:{"form":_vm.form,"hideForm":_vm.hideForm,"handleOpened":() => _vm.handleProps({ key: 'opened', value: !_vm.form.opened }),"attachModule":"bcTesteIshihara"}},[_c('IshiharaResume',{attrs:{"loading":_vm.loading,"ishihara":this.form.fields}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }